/**
 * Tier Encoding
 * Encode/decode tier parameter for URL
 */

import { TIER_SEEDS } from '../core/constants.js';

/**
 * Encode tier value to 6-char hash
 * @param {number} tier - 0-3
 * @returns {string|null}
 */
export function encodeTier(tier) {
  if (tier === null || tier === undefined || tier < 0 || tier > 3) {
    return null;
  }

  const seed = TIER_SEEDS[tier];
  let hash = seed;

  // Additional mixing
  hash = ((hash << 13) ^ hash) >>> 0;
  hash = ((hash << 7) ^ hash) >>> 0;
  hash = ((hash << 17) ^ hash) >>> 0;

  // Convert to 6-character string using base36 (0-9, a-z)
  const chars = '0123456789abcdefghijklmnopqrstuvwxyz';
  let result = '';
  let num = hash;

  // Generate exactly 6 characters
  for (let i = 0; i < 6; i++) {
    result = chars[num % 36] + result;
    num = Math.floor(num / 36);
  }

  return result;
}

/**
 * Decode 6-char hash to tier value
 * @param {string} encoded
 * @returns {number|null} - 0-3 or null
 */
export function decodeTier(encoded) {
  if (!encoded || encoded.length !== 6) {
    return null;
  }

  // Try each tier value and check if hash matches
  for (let tier = 0; tier <= 3; tier++) {
    const expectedHash = encodeTier(tier);
    if (expectedHash === encoded.toLowerCase()) {
      return tier;
    }
  }

  return null;
}

console.log('📦 Tier encoding module loaded');
